import {baseProdConfig} from '../base/prod.config';
import {cbsnewsStagingConfig} from './staging.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbsnewsProdConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseProdConfig, cbsnewsStagingConfig, {
  environmentName: "Cbs News Production Environment",
  ionicEnvName: 'prod',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbsnews/prod.config.ts